<div class="col-12">
  <div class="col-12 data-monitor-page">
    <!-- 全画面のモーダル -->
    <full-modal id="play-dm-modal" :contentId="modalContentId()" :showModal="showModal" />

    <!-- vue3.5以降でないとdeferが使用できないため、移動先の描画完了までteleport自体を描画しない -->
    <wrapped-teleport :destinationId="graphSettingsDestinationId()" :noRenderTeleport="!measureMounted"
      :disabled="!showModal">
      <div class="one-liner-btns">
        <!-- メモボタン -->
        <div class="left-side-btn">
          <b-button :class="showModal ? '' : 'ml-2'" variant="primary" size="sm" @click="parentOpenMemoModal">
            {{ $t('message.button_vehicle_dtc_note_modal') }}
          </b-button>
          <!-- CSVエクスポートボタン -->
          <b-button :class="showModal ? '' : 'ml-2'" variant="primary" size="sm" :disabled="inPlaying"
            @click="csvExport" @contextmenu.once="() => {debugCsvExport ? debugCsvExport() : ''}">
            {{ $t('message.file_export') }}
          </b-button>
        </div>

        <div class="right-side-btn">
          <!-- グラフ設定ボタン -->
          <no-text-svg-button :class="showModal ? `ml-2 ${BUTTON_TYPE.RIGHT_TOP}` : BUTTON_TYPE.RIGHT_TOP"
            variant="outline-info" :iconKey="ICON_KEY.CONFIG" @click="handleConfigureGraph" :disabled="btnDisabled"
            :title="$t('individual.button_data_monitor_graph_config')" />

          <!-- リセットズームボタン -->
          <no-text-svg-button :class="showModal ? `ml-2 ${BUTTON_TYPE.RIGHT_TOP}` : BUTTON_TYPE.RIGHT_TOP"
            variant="outline-info" :iconKey="ICON_KEY.RESET_ZOOM" @click="handleResetZoom($event)"
            :disabled="resetZoomBtnDisabled" :title="$t('individual.label_data_monitor_reset_zoom')" />

          <!-- 最大化ボタン -->
          <no-text-svg-button v-if="!showModal" :class="`ml-2 ${BUTTON_TYPE.RIGHT_TOP}`" variant="outline-info"
            :iconKey="ICON_KEY.MAXIMUM" @click="maximum()"
            :title="$t('individual.label_data_monitor_hint_maximize_action')" />
          <!-- 最小化ボタン -->
          <no-text-svg-button v-else :class="BUTTON_TYPE.RIGHT_TOP" variant="outline-info" :iconKey="ICON_KEY.MINIMUM"
            @click="minimum()" :title="$t('individual.label_data_monitor_hint_minimize_action')" />
        </div>
      </div>
    </wrapped-teleport>

    <teleport :to="`#${modalContentId()}`" :disabled="!modalContentId() || !showModal">
      <div v-if="!currentPercentage || currentPercentage !== 100" class="recollection-progress-bar">
        <!-- <div class="recollection-progress-bar"> -->
        <div class="progress" role="progressbar" aria-label="progress-area" aria-valuenow="currentPercentage"
          aria-valuemin="0" aria-valuemax="100">
          <div class="progress-bar" :style="{'width': currentPercentage + '%'}">{{ currentPercentage + ' %' }}</div>
        </div>
      </div>
    </teleport>

    <!-- 再生データのリストやグラフ -->
    <data-monitor class="{'dm-area': showSelect}" ref="data_monitor" parentName="data_recollection"
      :showSelect="showSelect" :inPlaying="inPlaying" :inExecution="false" :highlightItems="highlightItems"
      :dataMonitorFunctionSettings="dataMonitorFunctionSettings" :recollectionAtInfo="recollectionAtInfo"
      :atOperatingStatusList="atOperatingStatusList" :isPhase6AtRecollection="isPhase6AtRecollection"
      :showModal="showModal" :modalContentId="modalContentId()"
      :graphSettingsDestinationId="graphSettingsDestinationId()" :isOnlyCsvExport="isOnlyCsvExport"
      @toggle-playing="togglePlaying" @change-check-value="changeCheckValue" @back-select="backSelect"
      @update-total-count="updateTotalCount" @current-tab-changed="currentTabChanged"
      @zoom-pan-state-changed="zoomPanStateChanged" @maximum="maximum" @minimum="minimum"
      @measure-mounted="measureMountedEvent" />
  </div>

  <!-- CSVエクスポート時のプログレスバー -->
  <b-modal v-model="showCsvProgress" id="dm-play-export-csv-progress" size="lg" header-bg-variant="secondary"
    header-text-variant="light" no-stacking no-close-on-backdrop no-close-on-esc centered hide-footer>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('individual.data_monitor_csv_export_progress_title') }}
      </div>
    </template>

    <template v-slot:default>
      <div class="container-fluid mt-2 mb-2">
        <custom-progress :value="exportPercentage" :message="$t('individual.data_monitor_csv_export_progress_message')" />
      </div>
    </template>
  </b-modal>
</div>